import { SOURCING_EVENT_TEMPLATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/sourcing_event_templates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['sourcingEventTemplatesOverview']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
